var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSnsFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 24.0066C25 24.5552 24.5551 25 24.0066 25H19.4195V18.0295H21.7593L22.1096 15.3129H19.4195V13.5785C19.4195 12.792 19.6379 12.256 20.7658 12.256L22.2044 12.2554V9.8257C21.9555 9.79265 21.1016 9.71867 20.1082 9.71867C18.0341 9.71867 16.6143 10.9846 16.6143 13.3096V15.3129H14.2686V18.0295H16.6143V25H7.99343C7.44465 25 7 24.5552 7 24.0066V7.99349C7 7.44471 7.44465 7 7.99343 7H24.0066C24.5551 7 25 7.44471 25 7.99349V24.0066Z",
    fill: "#CDD6E3"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnsFacebook);
export default __webpack_public_path__ + "static/media/sns_facebook.e1e4f7ff59e22263213cac638c06a897.svg";
export { ForwardRef as ReactComponent };